import React from 'react';

const IconLayoutEleven = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="89"
            viewBox="0 0 89 89"
            fill="none"
        >
            <g filter="url(#filter0_d_5851_16073)">
                <path
                    d="M2 6.23153C2 3.89452 3.89452 2 6.23152 2H80.9236C83.2606 2 85.1551 3.89452 85.1551 6.23152V80.9236C85.1551 83.2606 83.2606 85.1551 80.9236 85.1551H6.23153C3.89452 85.1551 2 83.2606 2 80.9236V6.23153Z"
                    shape-rendering="crispEdges"
                />
                <rect
                    x="11.5"
                    y="30.5"
                    width="16"
                    height="40"
                    transform="rotate(-90 11.5 30.5)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
                <rect
                    x="11.5"
                    y="53.5"
                    width="16"
                    height="64"
                    transform="rotate(-90 11.5 53.5)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
                <rect
                    x="11.5"
                    y="76.5"
                    width="16"
                    height="64"
                    transform="rotate(-90 11.5 76.5)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
                <rect
                    x="-0.5"
                    y="-0.5"
                    width="16"
                    height="20"
                    transform="matrix(0 -1 -1 0 75 30)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
            </g>
        </svg>
    );
};

export default IconLayoutEleven;
